import {
  Component,
  ViewChild,
  OnInit,
  Compiler,
  HostListener,
  ChangeDetectionStrategy,
  OnChanges,
  OnDestroy,
  AfterViewChecked,
  ElementRef
} from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart } from '@angular/router';

import * as moment from 'moment';
import * as $$ from 'jquery';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { CommonService } from './commons/services/common.service';
import { AlertService } from './commons/services/alert.service';
import { VersionCheckService } from './commons/services/version-check.service';
import { environment } from '../environments/environment';
import { ChangeDetectorRef } from '@angular/core';
import { WebSocketSubject } from 'rxjs/internal/observable/dom/WebSocketSubject';
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged';
import { filter } from 'rxjs/operators';


declare var jquery: any;
declare var $: any;
declare var gapi: any;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'body',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],

})
export class AppComponent implements OnInit, OnChanges, AfterViewChecked, OnDestroy {

  @ViewChild('rappel', { static: true }) rappel;
  @ViewChild('msg', { static: true }) msg;
  @ViewChild('msgerror', { static: true }) msgError;
  @ViewChild('popTemplate', { static: true }) popTemplate
  @ViewChild('popTemplateChorus', { static: true }) popTemplateChorus
  @ViewChild('msgConsole', { static: true }) msgConsole;
  @ViewChild('tplApropos', { static: true }) tplApropos;
  @ViewChild('msgPasAcces', { static: true }) msgPasAcces;
  @ViewChild('panneauMailConfirmation', { static: true }) panneauMailConfirmation;
  @ViewChild('panneauSaisieCode', { static: true }) panneauSaisieCode;
  @ViewChild('panneauAttenteValidationApp', { static: true }) panneauAttenteValidationApp;
  title = 'app';
  public disabled: Boolean = false;
  isMsgPasAcces: Boolean = false;
  public load: Boolean = false;
  public status: { isopen: Boolean } = { isopen: false };
  public isRegister: Boolean = false;
  public infoUser = {};
  public showPass: Boolean = false;
  public listeSite: any[] = [];
  public isFocuslogin: Boolean = false;
  public isFocuspass: Boolean = false;
  public isFocussociete: Boolean = false;
  public date: Date = new Date();
  public showNav: Boolean = true;
  public showClient: Boolean = true;
  public current;
  public listerappel = [];
  public listeSociete = [];
  public israppel: Boolean = false;
  public showBrd: Boolean = false;
  public isFin: Boolean = false;
  public isTop: Boolean = true;
  public user;
  public logoLoginLeft = 'assets/images/kerlog.svg';
  public logoLoginRight = 'assets/images/ecorec.svg';
  public iconMenuLeft = 'assets/images/kerlog-favicon.png';
  public iconTampon = 'assets/images/Tampon_Kerlog.svg';
  public titleNav = 'Ecorec';
  isHolding: Boolean = false;
  isFirst: Boolean = false;
  paramLogin: any = {}
  public colorMenu = '#376194';
  couleurErreur = '#FF0000';
  couleurBordureDefaut = 'rgb(204, 204, 204)';
  // public colorMenu = '#326150';
  // public colorMenu = '#b6c933';
  public error = '';

  objetError = {};
  objTwoFactorAuth: any = {
    code: ['', '', '', '', '', '']
  };

  latitude: number = 0.0;
  longitude: number = 0.0;
  isModalPanneauAttenteValidationApp: Boolean = false;
  isModalMail: Boolean = false;

  index = 0;
  changerCouleurMail: Boolean = false
  isCodevalidationRempli: Boolean = false;

  pasConnexion: Boolean = false;
  isEcobennes: Boolean = false;
  navigateurPasSupporter: Boolean = false;
  bloquerClient: Boolean = false;

  userGoogle: any;
  gapiSetup: any;
  authInstance;
  errorGoogle;

  private socket$: WebSocketSubject<any>;
  websocket;
  env: any = {};

  checkedall: Boolean = false;
  selected = [];
  PageTitleNotification = {
    Vars: {
      OriginalTitle: document.title,
      Interval: null
    },
    On: function (notification, intervalSpeed) {
      const ctrl = this;
      ctrl.Vars.Interval = setInterval(function () {
        document.title = (ctrl.Vars.OriginalTitle === document.title)
          ? notification
          : ctrl.Vars.OriginalTitle;
      }, (intervalSpeed) ? intervalSpeed : 1000);
    },
    Off: function () {
      clearInterval(this.Vars.Interval);
      document.title = this.Vars.OriginalTitle;
    }
  };
  loginClick: boolean;
  keyLicenceGoogleAPI = '';
  affichePagelogin = true;

  code: string[] = ['', '', '', '', '', ''];
  timeLeft: number = 15 * 60; // 15 minutes in seconds
  interval: any;
  minutes: number = 0;
  seconds: number = 0;
  isSendMailErrorEcoDA: Boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.showBrd = this.showBrand();
  }

  /** Deblocage du planning lorsque l'utilisateur ferme le navigateur */

  @HostListener('window:load', ['$event'])
  loadHandler(event) {
  }

  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    if (this.common.isDragDrop && this.common.planningInUse) {
      this.removeAccesPlanning();
      this.common.planningInUse = false;
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(event) {
    if (this.common.isDragDrop && this.common.planningInUse) {
      this.removeAccesPlanning();
      this.common.planningInUse = false;
    }

    // this.common.userConnectedLogout();
  }

  @HostListener('window:onerror', ['$event'])
  onerrorHander(event) {
    console.log(event);
  }


  constructor(public _compiler: Compiler, public router: Router, public common: CommonService,
    public alert: AlertService, public modalService: BsModalService, protected checkversion: VersionCheckService,
    private cdRef: ChangeDetectorRef, private route: ActivatedRoute) {
    this._compiler.clearCache();
    this.common.local.remove('hasSpinner');
    // this.router.navigateByUrl('');
    // Detection : changement routeur
    this.isFirst = true;
    this.current = window.location.href;
    this.user = this.common.local.getObject('userDetail');
    this.common.modalService = this.modalService;
    this.common.checkDroit();
    const originalNavigateByUrl = this.router.navigateByUrl.bind(this.router);

    this.router.navigateByUrl = (...args: any[]) => {
      console.log('navigateByUrl intercepted:', args);
      this.common.navigatedInternally = true;
      // Appeler la vraie méthode sinon
      return originalNavigateByUrl(...args);
    };

    this.common.doSomethingAfterCloseEchape.subscribe(evt => {
      this.isModalMail = false;
    })

    router.events.pipe(distinctUntilChanged((previous: any, current: any) => {
      if (current instanceof NavigationEnd) {
        if (environment.isOpenId) {
          if (current.url.includes('/creationDevis') || current.url.includes('/empty') || current.url.includes('/loading')) {
            return previous.url === current.url;
          }
        } else {
          if (current.url && current.url !== '/') {
            return false;
          } else {
            return previous.url === current.url;
          }
        }
      }
      if (current instanceof NavigationStart) {
        if (this.common.navigatedInternally) {
          console.log('Navigation par clic (interne)');
        } else {
          console.log('Navigation manuelle (URL ou reload)');
        }

      }
      return true;
    })).subscribe((x: any) => {
      this.common.navigatedInternally = false;
      this.common.indexNameAutocomplete = 0;
      //  || x.url.includes('/ecofact')
      if (x.url.includes('/ecobennes') || x.url.includes('/ecofact') || x.url.includes('/ecodd/')) {
        this.isEcobennes = true;
      } else {
        this.isEcobennes = false;
      }
      if (environment.moduleEcoportailOnly) {
        this.showClient = true;
        environment.url = environment.api_url_ecoportail;
        this.common.obligatoireCodeClient();
        const isNotAccess = !x.url.includes('/access/');
        if (isNotAccess && !x.url.includes('/ecoportail')) {
          this.router.navigateByUrl('/ecoportail/home');
        }

      } else {
        // hide nav
        if (x.url.includes('/ecoportail')) {
          this.showClient = true;
          environment.url = environment.api_url_ecoportail;
          // this.showNav = false;
        } else if (x.url.includes('/payfip')) {
          this.common.isAppelPayfipUserAnonyme = true;
          // console.log('condition 2 payfip')
        } else {
          this.showClient = false;
          this.common.checkSessions();
          this.common.checkDroit();
          environment.url = environment.api_url;
          this.showClient = false;
          const stylePage = this.common.local.getObject('stylePage');
          if (!stylePage) {
            this.loadStylePage();
          }
          if (x.url === '/' && !this.needLogin()) {
            this.getSocieteFille();
          } else {
            this.common.user = this.common.local.getObject('userInfo') || [];
          }
        }
      }

      $('#navbarSupportedContent').removeClass('show')
      // todo :  système qui envoie les données à enregistrer au serveur
      this.getChampVisible();
    });
  }


  saveRouteVisited(route: any) {
    if (this.common.lastNavigate !== route.url) {
      this.common.lastNavigate = route.url;
      switch (route.url) {
        case "/ecoportail/login":
          this.common.saveNavigation(1);
          break;
        case "/ecoportail/home":
          this.common.saveNavigation(2);
          break;
        case "/ecoportail/document/":
          this.common.saveNavigation(3);
          break;
        case "/ecoportail/rapport":
          this.common.saveNavigation(4);
          break;
        case "/ecoportail/commande":
          this.common.saveNavigation(5);
          break;
        case "/ecoportail/messagerie":
          this.common.saveNavigation(7);
          break;
        case "/ecoportail/cmdecocomposteur":
          this.common.saveNavigation(9);
          break;
        case "/ecoportail/decheterie":
          this.common.saveNavigation(10);
          break;
        case "/ecoportail/demande_enlevement":
          this.common.saveNavigation(11);
          break;
        case "/ecoportail/teom":
          this.common.saveNavigation(12);
          break;
        case "/ecoportail/paiement":
          this.common.saveNavigation(13);
          break;
        case "/ecoportail/rdv":
          this.common.saveNavigation(14);
          break;
        case "/ecoportail/rdv/mesrdv":
          this.common.saveNavigation(14);
          break;
      }
    }
  }

  async ngOnInit() {
    console.log(this.detectBrowserName())
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const routeVisited = {
          url: event.urlAfterRedirects,
          timestamp: new Date()
        };
        this.saveRouteVisited(routeVisited);
      });
    this.addLinkOrScript('https://static.payzen.eu/static/js/krypton-client/V4.0/ext/neon-reset.css', 'style');
    this.addLinkOrScript('https://maps.googleapis.com/maps/api/js?libraries=geometry&key=AIzaSyB7bGoJTh-PD6sdlIVJPxPAFb2Zc2OAj2s', 'script');
    this.addLinkOrScript('https://unpkg.com/@google/markerclustererplus@4.0.1/dist/markerclustererplus.min.js', 'script');
    this.addLinkOrScript('https://static.payzen.eu/static/js/krypton-client/V4.0/ext/neon.js', 'script');
    if (!environment.moduleEcoportailOnly && this.detectBrowserName() !== 'chrome' && this.detectBrowserName() !== 'firefox' && this.detectBrowserName() !== 'safari') {
      this.navigateurPasSupporter = true;
      console.log(`Votre navigateur n'est pas compatible avec la suite EcoREC. Nous vous invitons à utiliser un nouveau navigateur.
 Si vous rencontrez des difficultés, il est possible que votre version nécessite une mise à jour. Veuillez vérifier que vous remplissez les conditions suivantes :
 Chrome : version minimum 92.0.4515.159
 Firefox : version minimum 90.0
 Safari : version minimum 15.0
 
 Merci pour votre compréhension.`)
    } else {
      console.log(this.detectBrowserVersion())
      // versionning production
      this.current = window.location.href;
      const current = window.location.href;
      if (this.current.includes('/access/')) {
        const indexOfaccess = this.current.indexOf('/access/');
        const codeExterneClient = this.current.substring(indexOfaccess + 8);
        if (!codeExterneClient.includes('/')) {
          this.common.codeExterneClient = codeExterneClient;
          this.common.local.set('codeExterneClient', codeExterneClient);
        }
      }
      this.env = environment || {};
      this.common.popTemplate = this.popTemplate;
      this.common.popTemplateChorus = this.popTemplateChorus;
      this.common.tplApropos = this.tplApropos;
      if (environment.production) {
        this.checkversion.initVersionCheck(environment.versionCheckURL, 10000);
      }
      this.common.changeColor();

      this.loadStylePage();
      this.load = true;
      if (environment.moduleEcoportailOnly) {
        this.showClient = true;
        this.consoleFct();
        this.common.isloadEcoportail = true;
        if (!this.current.includes('/ecoportail')) {
          this.router.navigateByUrl('/ecoportail/home');
        }
        clearInterval(this.common.intervalRappel);
      } else {
        if (this.current.includes('/ecoportail')) {
          this.showClient = true;
          this.common.isloadEcoportail = true;
          clearInterval(this.common.intervalRappel);
        } else if (this.current.includes('/payfip')) {
          this.common.isAppelPayfipUserAnonyme = true;
          clearInterval(this.common.intervalRappel);
        } else {
          if (environment.moduleEcomobileOnly) {
            this.showClient = true;
            // this.common.isloadEcoportail = true;
            if (!this.current.includes('/ecomobile')) {
              this.router.navigateByUrl('/ecomobile/cartographie');
            }
            clearInterval(this.common.intervalRappel);
          } else {
            if (this.current.includes('/ecomobile')) {
              this.showClient = true;
              // this.common.isloadEcoportail = true;
              clearInterval(this.common.intervalRappel);
            } else {
              this.showClient = false;
              this.common.initTimer();
              if (this.current.includes('/creationDevis')) {
                environment.isOpenId = true;
                this.router.navigateByUrl('/loading');
                return this.common.getLogoAndColor().then(data => {
                  this.keyLicenceGoogleAPI = data.clientIDGoogle || environment.keyLicenceGoogleAPI;
                  this.ngOnInitOpenID();
                });
              } else {
                this.common.local.remove('token');
                this.router.navigateByUrl('/loading');
                return this.common.getLogoAndColor().then(data => {
                  const SSO = data.SSO === '1' ? true : false;
                  this.common.Shibboleth = SSO;
                  if (SSO) {
                    this.loginSansLogin();
                  } else {
                    this.affichePagelogin = false;
                    this.router.navigateByUrl('');
                    // add function fin init
                    this.showBrd = this.showBrand();
                    this.fonctionFinInit();
                  }

                });

              }
            }
          }
        }
      }
    }

  }

  detectBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    const browserVersion = this.getBrowserVersion();
    console.log(browserVersion);
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('edg') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:

        if (parseFloat(browserVersion[1]) < 92) {
          console.log('Chrome < 92')
          return 'other';
        } else {
          return 'chrome';
        }
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        if (parseFloat(browserVersion[1]) < 90) {
          console.log('firefox < 90')
          return 'other';
        } else {
          return 'firefox';
        }
      case agent.indexOf('safari') > -1:
        if (parseFloat(browserVersion[1]) < 15) {
          console.log('safari < 15')
          return 'other';
        } else {
          return 'safari';
        }
      default:
        return 'other';
    }
  }

  detectBrowserVersion() {
    var userAgent = navigator.userAgent, tem,
      matchTest = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(matchTest[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
      return 'IE ' + (tem[1] || '');
    }
    if (matchTest[1] === 'Chrome') {
      tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    matchTest = matchTest[2] ? [matchTest[1], matchTest[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = userAgent.match(/version\/(\d+)/i)) != null) matchTest.splice(1, 1, tem[1]);
    return matchTest.join(' ');
  }

  getBrowserVersion() {
    const userAgent: any = navigator.userAgent;
    let tempMatch: any;
    let versionMatch: any =
      userAgent.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];
    if (/trident/i.test(versionMatch[1])) {
      tempMatch = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
      return 'IE ' + (tempMatch[1] || '');
    }
    if (versionMatch[1] === 'Chrome') {
      tempMatch = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
      if (tempMatch != null) {
        return tempMatch.slice(1).join(' ').replace('OPR', 'Opera');
      }
    }
    versionMatch = versionMatch[2]
      ? [versionMatch[1], versionMatch[2]]
      : [navigator.appName, navigator.appVersion, '-?'];
    if ((tempMatch = userAgent.match(/version\/(\d+)/i)) != null)
      versionMatch.splice(1, 1, tempMatch[1]);
    return versionMatch;
  }



  async ngOnDestroy() {
    this.common.subscription.unsubscribe();
    this.objTwoFactorAuth = {
      code: ['', '', '', '', '', '']
    };
  }

  fonctionFinInit(notCkeck?) {
    this.consoleFct();
    if (!this.showClient && !notCkeck) {
      this.common.checkSessions().then(dt => {
        if (dt) {
          this.getParamSociete();
          this.common.getWarDeployer().then(() => {
            if (this.common.isDragDrop && this.common.isEcobennes && !this.common.isPrestation) {
              this.removeAccesPlanning();
            }
          });

          if (this.common.isRappel) {
            this.loadRappel();
          }

          this.common.DBGestionDemandeEcoGED5();
          this.common.DBGestionDemandeEcoGED12();
          this.common.DBGestionDemandeEcoGED28();
          this.common.DBGestionDemandeEcoGED27();
        }
      });
    }

    this.common.local.remove('resourceId');
    this.showBrd = this.showBrand();
    const ctrl = this;
    this.closeFunction();
    setTimeout(function () {
      $('#login-input').focus();
      ctrl.showBrd = ctrl.showBrand();
    }, 500);

  }

  ngOnChanges(changes) {
    this.loadStylePage();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }


  async ngOnInitOpenID() {
    this.consoleFct();

    const authed = await this.checkIfUserAuthenticated();
    if (!authed) {
      this.authenticate();
      return;
    }

    // garde-fous
    if (!this.authInstance?.currentUser?.get) {
      // auth pas dispo malgré authed=true (init partielle / script bloqué)
      this.authenticate();
      return;
    }

    this.userGoogle = this.authInstance.currentUser.get();

    try {
      const datas = await this.common.isHasCompteConnected({ token: this.userGoogle });

      if (!datas?.data) {
        // pas de compte lié -> tu peux décider quoi faire ici
        this.authenticate();
        return;
      }

      this.common.local.set('token', datas.data['token']);

      const sessionOk = await this.common.checkSessions();

      if (sessionOk) {
        this.consoleFct();
        this.fonctionFinInit(true);

        if (environment.isOpenId) {
          if (!this.current.includes('/creationDevis')) {
            this.router.navigateByUrl('/empty');
          } else {
            this.reloadComponent();
          }
        }
      } else {
        this.infoUser['login'] = datas.data['login'];
        this.infoUser['password'] = datas.data['pwd'];
        this.getSiteOpenID();
      }
    } catch (e) {
      // important : sinon erreurs silencieuses et état cassé
      console.error('OpenID init failed', e);
      this.authenticate(); // ou un modal / message, selon ton UX
    }
  }

  async initGoogleAuth(): Promise<void> {
    if (this.gapiSetup && this.authInstance) return;

    if (typeof (window as any).gapi === 'undefined') {
      throw new Error('gapi n’est pas chargé (script Google manquant ou bloqué).');
    }

    await new Promise<void>((resolve) => {
      gapi.load('auth2', () => resolve());
    });

    try {
      const auth = await gapi.auth2.init({
        client_id: this.keyLicenceGoogleAPI,
        plugin_name: 'auth2 ecorec',
      });

      this.authInstance = auth;
      this.gapiSetup = true;
    } catch (err: any) {
      this.gapiSetup = false;
      this.authInstance = undefined;

      this.error = err?.details || err?.error || err?.message || 'Erreur Google Auth';
      this.common.openModal(this.modalService, this.msg);

      // IMPORTANT: on propage l’erreur pour que l'appelant sache que ça a échoué
      throw err;
    }
  }

  async authenticate() {
    if (environment.isOpenId) {
      // Initialize gapi if not done yet
      if (!this.gapiSetup) {
        await this.initGoogleAuth();
      }

      // Resolve or reject signin Promise
      return new Promise(async () => {
        await this.authInstance.signIn().then(
          userGoogle => {
            this.userGoogle = userGoogle;
            this.common.local.setObject('userGoogle', this.userGoogle);
            this.common.isHasCompteConnected({
              token: this.userGoogle
            }).then(datas => {
              if (datas.data) {
                this.common.local.set('token', datas.data['token']);
                this.infoUser['login'] = datas.data['login'];
                this.infoUser['password'] = datas.data['pwd']
                this.getSiteOpenID();
              }
            });
          },
          error => this.errorGoogle = error);
      });
    }
  }

  getSiteOpenID() {
    this.common.post('', {
      param: {
        'servlet': 'DBGetListSiteUser',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'NOM_UTILISATEUR': this.infoUser['login'],
          'IS_HOLDING': {
            'typeParam': 'boolean',
            'valeur': this.isHolding ? true : false
          }
        }
      }
    }).then(datas => {
      if (datas.data) {
        this.listeSite = datas.data[0] || [];
        const selectedSite = datas.data[1] || false;
        this.common.local.setObject('listeSite', this.listeSite);
        if (this.listeSite.length) {
          if (selectedSite) {
            this.infoUser['site'] = selectedSite;
          } else {
            this.infoUser['site'] = this.listeSite[0].id;
          }
          this.login(true);
        }
      }
    }).catch(error => console.log(error));
  }

  async checkIfUserAuthenticated(): Promise<boolean> {
    try {
      if (!this.gapiSetup || !this.authInstance) {
        await this.initGoogleAuth();
      }
    } catch {
      return false; // init a échoué
    }

    return !!this.authInstance?.isSignedIn?.get?.();
  }

  reloadComponent() {
    const url = (this.current).split('/');
    const id1 = url[url.length - 2] && url[url.length - 2] !== 'creationDevis' ? url[url.length - 2] : url[url.length - 1];
    const id2 = url[url.length - 2] && url[url.length - 2] !== 'creationDevis' ? url[url.length - 1] : 0;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['/creationDevis', id1, id2]);
  }

  showBrand() {
    const menu = $('#menu');
    if (menu[0]) {
      this.showBrd = menu[0].scrollWidth > (menu[0].clientWidth + 5) ? true : false;
      return menu[0].scrollWidth > (menu[0].clientWidth + 5) ? true : false;
    } else {
      this.showBrd = false;
      return false;
    }
  }

  initSocket() {
    let url = '';
    const ctrl = this;
    const RemoveLastDirectoryPartOf = function (the_url) {
      const the_arr = the_url.split('/');
      the_arr.pop();
      return (the_arr.join('/'));
    }
    let base_url = document.getElementsByTagName('base')[0].href;
    if (environment.production) {
      base_url = environment.base_url;
      base_url = base_url.replace(/^http:/, 'ws:');
      base_url = base_url.replace(/^https:/, 'wss:');
      // url = `ws://${window.location.host}/${environment.api_ws}${this.common.user[0]}/${this.common.user[2]}`;
      url = `${base_url}/${environment.api_ws}${this.common.user[0]}/${this.common.user[2]}`;
    } else {
      base_url = environment.base_url;
      base_url = base_url.replace(/^http:/, 'ws:');
      base_url = base_url.replace(/^https:/, 'wss:');
      url = `${base_url}${environment.api_ws}${this.common.user[0]}/${this.common.user[2]}`;
    }
    console.log('Socket URL', url);
    const websocket = new WebSocket(url);

    this.common.websocketReminder = websocket;
    websocket.onopen = function (evt) {
      console.log('WebSocket ouvert');
    };

    websocket.onclose = function (evt) {
      console.log('WebSocket déconnecté');
    };

    websocket.onmessage = function (evt) {
      console.log('reminder deplacement ... ', JSON.parse(evt.data));
      const data = JSON.parse(evt.data);
      const contenu = (data.contenu || '').toLowerCase();

      if (contenu === 'ok') {
        ctrl.loadRappelSocket();
      }
    };

    websocket.onerror = function (evt) {
      console.log('WebSocket erreur', evt);
    };
  }

  public login(isDepuisHome?, depuisPassOubtn?): void {
    this.paramLogin['isDepuishome'] = isDepuisHome || false;
    this.paramLogin['depuisPassOubtn'] = depuisPassOubtn || false;
    const site = this.infoUser['site'];
    this.common.isNotFirstLoad = true;
    this.isModalMail = false;
    this.common.valeurAvantChagementPlanningEcobennes = null;
    if (!this.common.isLoadingApp && this.infoUser['login'] && this.infoUser['password'] && this.infoUser['site']) {
      const login = this.infoUser['login'];
      this.common.isLoadingApp = true;
      const param = {
        'servlet': 'DBGetParamConnexion',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'USER': this.infoUser['login'],
          'PWD': this.infoUser['password'],
          // 'TESTPWD': {
          //   'typeParam': 'boolean',
          //   'valeur': '1'
          // },
          'CLEF_SITE': {
            'typeParam': 'int',
            'valeur': this.infoUser['site']
          }
        }
      };

      if (this.objTwoFactorAuth['step'] === "ETAPE_0" || this.isSendMailErrorEcoDA) {
        if (this.isSendMailErrorEcoDA) {
          this.objTwoFactorAuth['step'] = "ETAPE_0";
        }
        param['data']['NUMERO_ETAPE_DOUBLE_FACTEUR'] = {
          'typeParam': 'int',
          'valeur': 1
        };
        param['data']['MAIL'] = {
          'typeParam': 'string',
          'valeur': this.objTwoFactorAuth['mail'] || ''
        };
        param['data']['LATITUDE'] = {
          'typeParam': 'double',
          'valeur': this.latitude || 0.0
        };
        param['data']['LONGITUDE'] = {
          'typeParam': 'double',
          'valeur': this.longitude || 0.0
        };
        param['data']['BROWSER'] = {
          'typeParam': 'string',
          'valeur': this.detectBrowserName() || ''
        };
        param['data']['SEND_MAIL_ERROR_ECODA'] = {
          'typeParam': 'boolean',
          'valeur': this.isSendMailErrorEcoDA ? true : false
        }
      }

      if ((this.objTwoFactorAuth['step'] === "ETAPE_1") || (this.objTwoFactorAuth['step'] === "ETAPE_2")) {
        param['data']['NUMERO_ETAPE_DOUBLE_FACTEUR'] = {
          'typeParam': 'int',
          'valeur': 2
        };
        param['data']['MAIL'] = {
          'typeParam': 'string',
          'valeur': this.objTwoFactorAuth['mail'] || ''
        };
        param['data']['CODE_SIX_CHIFFRES'] = this.objTwoFactorAuth['codeString'] + "";
      }

      if ((this.objTwoFactorAuth['step'] === "ETAPE_3") && !this.isSendMailErrorEcoDA) {
        param['data']['NUMERO_ETAPE_DOUBLE_FACTEUR'] = {
          'typeParam': 'int',
          'valeur': 3
        };
        param['data']['MAIL'] = {
          'typeParam': 'string',
          'valeur': this.objTwoFactorAuth['mail'] || ''
        };
        param['data']['CLEF_REQUEST'] = {
          'typeParam': 'string',
          'valeur': this.objTwoFactorAuth['clefRequest'] || ''
        };
      }


      if (this.isHolding && !isDepuisHome) {
        this.common.local.setObject('societeHolding', this.infoUser['societe']);
        this.common.local.set('isHolding', '' + true);
      }

      console.log(param);

      this.common.post('', { param: param }, !this.isModalPanneauAttenteValidationApp).then(datas => {
        if (datas.data) {
          // securisation compte admin
          if (datas.data[1] === "USER_ADMIN_KERLOG") {
            this.common.isLoadingApp = false;
            this.objTwoFactorAuth['step'] = datas.data[2];
            if (this.objTwoFactorAuth['step'] === "ETAPE_0") {
              this.isModalPanneauAttenteValidationApp = false;
              this.isModalMail = true;
              this.getLocation();
              this.common.openModal(this.modalService, this.panneauMailConfirmation);
              setTimeout(() => {
                if ($('#panneaumail').length > 0) {
                  $('#panneaumail').focus();
                }
              }, 500);
              return false;
            } else if (this.objTwoFactorAuth['step'] === "ETAPE_1") {
              this.startTimer(0);
              this.isSendMailErrorEcoDA = false;
              this.common.openModal(this.modalService, this.panneauSaisieCode);
              return false
            } else if (this.objTwoFactorAuth['step'] === "ETAPE_2") {
              this.objTwoFactorAuth['error'] = "Le code que vous avez entré est incorrect";
            } else if (this.objTwoFactorAuth['step'] === "ETAPE_3") {
              const STATUS_REQUEST = datas.data[4];
              console.log('STATUS_REQUEST = ' + STATUS_REQUEST, this.minutes, this.seconds);
              this.objTwoFactorAuth['mail'] = datas.data[5];
              this.objTwoFactorAuth['clefRequest'] = datas.data[6];
              if (STATUS_REQUEST === "INITIAL") {
                if (!this.isModalPanneauAttenteValidationApp) {
                  this.startTimer(1);
                  this.common.openModal(this.modalService, this.panneauAttenteValidationApp);
                  this.isModalPanneauAttenteValidationApp = true;
                }
                console.log('INITIAL', this.minutes, this.seconds);
                if (!this.isSendMailErrorEcoDA && (this.minutes != 0 || this.seconds != 0)) {
                  setTimeout(() => {
                    this.ckeckResponseNotificationFirebase();
                  }, 5000);
                }
              } else if (STATUS_REQUEST === "TIME_OUT") {
                this.objTwoFactorAuth['error'] = "Temps d'attente de l'identification à double facteur depassé.";
                this.isModalPanneauAttenteValidationApp = false;
              } else if (STATUS_REQUEST === "REFUSED") {
                this.objTwoFactorAuth['error'] = "Identification à double facteur refusé.";
                this.isModalPanneauAttenteValidationApp = false;
              }
            }
            // 
          } else {
            this.isModalPanneauAttenteValidationApp = false;
            this.isSendMailErrorEcoDA = false;
            this.common.closeModal();
            this.loadAfterLogin(datas);
          }
        } else {
          this.common.closeModal();
          this.loginClick = false;
          // this.alert.error('Utilisateur inconnu');
          this.error = `Nom d'utilisateur ou mot de passe incorrect`;
          this.common.openModal(this.modalService, this.msgPasAcces);
          this.loginClick = false;
          this.common.isLoadingApp = false;
        }
      }).catch(error => {
        this.loginClick = false;
        this.common.isLoadingApp = false;
      });
    } else {
      if (depuisPassOubtn && (!this.infoUser['login'] || !this.infoUser['password'])) {
        this.error = `Nom d'utilisateur ou mot de passe incorrect`;
        this.common.openModal(this.modalService, this.msgPasAcces);
      }
      this.common.isLoadingApp = false;
    }
  }

  loginFromHome() {
    const datas = { data: this.common.local.getObject('userInfo') };
    this.loadAfterLogin(datas);
  }

  loadAfterLogin(datas) {
    const site = this.infoUser['site'];
    const login = this.infoUser['login'];

    this.getUser(datas.data[0]).then(() => {
      // this.loginEcoportail().then((logEcoportail) => {
      this.common.getListSite(this.infoUser['login'], this.isHolding);
      this.common.userConnectedGetMessage(datas.data[0]).then(op4 => {
        if (op4 && op4.message && op4.message !== '') {
          this.error = op4.message;
          this.common.openModal(this.modalService, this.msg);
          this.common.removeConnection();
          this.loginClick = false;
          this.common.isLoadingApp = false;
        } else {
          this.common.userConnectedLogin(datas.data[0]).then(conx => {
            if (conx && conx.message && conx.message !== '') {
              this.error = conx.message;
              this.loginClick = false;
              this.common.isLoadingApp = false;
              this.common.openModal(this.modalService, this.msg);
              this.common.removeConnection();
            } else {
              // this.getUser(datas.data[0]);
              datas.data[2] = this.infoUser['site'];
              this.common.user = datas.data;
              this.common.local.setObject('userInfo', datas.data);

              // if (!this.common.local.getObject('globalParam')) {

              // }

              // get param societe

              this.getParamSociete().then(data => {
                this.common.checkDroit(datas.data[0]);
                const ctrl = this;
                this.getDetail(site).then(() => {
                  this.common.changeFlavicon();
                  this.getDBGetParametresHolding(login).then(() => {
                    this.common.getParam().then(() => {
                      this.common.isLoadingApp = false;
                      if (environment.isOpenId) {
                        if (!this.current.includes('/creationDevis')) {
                          this.router.navigateByUrl('/empty');
                        } else {
                          ctrl.reloadComponent();
                          setTimeout(function () {
                            document.location.reload();
                          }, 500);
                        }
                      }
                      this.common.checkDroit();
                      if (this.common.isRappel) {
                        this.loadRappel();
                      }
                    }).catch(e => {
                      this.common.isLoadingApp = false;
                    });
                  }).catch(err => {
                    this.common.isLoadingApp = false;
                  });
                });
                this.loginClick = false;

                setTimeout(function () {
                  ctrl.showBrd = ctrl.showBrand();
                }, 500);
                this.infoUser = {};
                this.common.isLogin = !this.common.isLogin;
                this.common.getWarDeployer();
                this.common.DBGestionDemandeEcoGED5();
                this.common.DBGestionDemandeEcoGED12();
                this.common.DBGestionDemandeEcoGED28();
                this.common.DBGestionDemandeEcoGED27();
                if (!environment.isOpenId) {
                  this.router.navigateByUrl('/');
                }

              }).catch(err => {
                this.common.isLoadingApp = false;
              });
            }
          }).catch(err => {
            this.common.isLoadingApp = false;
          });
        }
      }).catch(err => {
        this.common.isLoadingApp = false;
      });
      // })
      // const op4 = this.common.userConnectedGetMessage(datas.data[0])

    }).catch(err => {
      this.common.isLoadingApp = false;
    });
  }


  public loginSansLogin(): void {
    this.common.valeurAvantChagementPlanningEcobennes = null;
    this.consoleFct();
    let site = this.infoUser['site'];
    this.common.isNotFirstLoad = true;
    const login = this.infoUser['login'];
    this.common.isLoadingApp = true;
    const param = {
      'servlet': 'DBGetParamConnexion',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'USER': '',
        'PWD': '',
        // 'TESTPWD': {
        //   'typeParam': 'boolean',
        //   'valeur': '1'
        // },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': '1'
        }
      }
    };


    this.common.post('', { param: param }).then(datas => {
      if (datas.data) {
        if (datas.data[0]) {
          this.getUser(datas.data[0]).then(() => {
            // this.loginEcoportail().then((logEcoportail) => {
            // const op4 = this.common.userConnectedGetMessage(datas.data[0])
            this.infoUser['login'] = this.common.userDetail['login'];
            this.common.getListSite(this.infoUser['login'], this.isHolding);
            this.common.userConnectedGetMessage(datas.data[0]).then(op4 => {
              if (op4 && op4.message && op4.message !== '') {
                this.error = op4.message;
                this.common.openModal(this.modalService, this.msg);
                this.common.removeConnection();
                this.loginClick = false;
                this.common.isLoadingApp = false;
              } else {
                this.common.userConnectedLogin(datas.data[0]).then(conx => {
                  if (conx && conx.message && conx.message !== '') {
                    this.error = conx.message;
                    this.loginClick = false;
                    this.common.isLoadingApp = false;
                    this.common.openModal(this.modalService, this.msg);
                    this.common.removeConnection();
                  } else {
                    // this.getUser(datas.data[0]);
                    datas.data[2] = parseInt(datas.data[2], 10);
                    site = datas.data[2];
                    this.common.user = datas.data;
                    this.common.local.setObject('userInfo', datas.data);
                    this.getParamSociete().then(data => {
                      this.common.checkDroit(datas.data[0]);
                      const ctrl = this;
                      this.getDetail(site).then(() => {
                        this.common.changeFlavicon();
                        this.getDBGetParametresHolding(login).then(() => {
                          this.common.getParam().then(() => {
                            this.common.isLoadingApp = false;
                            if (environment.isOpenId) {
                              if (!this.current.includes('/creationDevis')) {
                                this.router.navigateByUrl('/empty');
                              } else {
                                ctrl.reloadComponent();
                                setTimeout(function () {
                                  document.location.reload();
                                }, 500);
                              }
                            }
                            this.common.checkDroit();
                            if (this.common.isRappel) {
                              this.loadRappel();
                            }
                          }).catch(e => {
                            this.common.isLoadingApp = false;
                          });
                        }).catch(err => {
                          this.common.isLoadingApp = false;
                        });
                      });
                      this.loginClick = false;

                      setTimeout(function () {
                        ctrl.showBrd = ctrl.showBrand();
                      }, 500);
                      this.infoUser = {};
                      this.common.isLogin = !this.common.isLogin;
                      this.common.getWarDeployer();
                      this.common.DBGestionDemandeEcoGED5();
                      this.common.DBGestionDemandeEcoGED12();
                      this.common.DBGestionDemandeEcoGED28();
                      this.common.DBGestionDemandeEcoGED27();

                      if (!environment.isOpenId) {
                        this.router.navigateByUrl('/');
                      }

                    }).catch(err => {
                      this.common.isLoadingApp = false;
                    });
                  }
                }).catch(err => {
                  this.common.isLoadingApp = false;
                });
              }
            }).catch(err => {
              this.common.isLoadingApp = false;
            });
            // });
          }).catch(err => {
            this.common.isLoadingApp = false;
          });

        } else {
          this.error = 'Utilisateur non existant';
          this.common.openModal(this.modalService, this.msg);
        }

      } else {
        this.loginClick = false;
        // this.alert.error('Utilisateur inconnu');
        this.error = `Nom d'utilisateur ou mot de passe incorrect`;
        this.common.openModal(this.modalService, this.msgPasAcces);
        this.loginClick = false;
        this.common.isLoadingApp = false;
        this.router.navigateByUrl('');
        this.affichePagelogin = false;
      }
    }).catch(error => {
      this.loginClick = false;
      this.common.isLoadingApp = false;
      // this.error = `Nom d'utilisateur ou mot de passe incorrect`;
      // this.common.openModal(this.modalService, this.msgPasAcces);
    });

  }


  async getParamSociete() {
    await this.common.post('', {
      param: {
        'servlet': 'DBGetSociete',
        'module': 'Recylog',
        'type': 'tableau',
        'compression': 'false',
        'data': []
      }
    }).then(data => {
      this.common.paramSociete = data.data;
      if (data.data) {
        data.data['nbDigitDevise'] = data.data['nbDigitDevise'] || 0;
        data.data['nbrDigitTarif'] = data.data['nbrDigitTarif'] || 0;
        data.data['nbrDigitQte'] = data.data['nbrDigitQte'] || 0;
        data.data['nbrDigitQteEcopol'] = data.data['nbrDigitQteEcopol'] || 0;
        data.data['nbrDigitIndice'] = data.data['nbrDigitIndice'] || 0;
        this.common.local.setObject('paramSociete', data.data || {});
        // this.common.checkSessions();
      } else {
        if (data.message) {
          this.common.local.setObject('paramSociete', {});
          console.error(data.message);
        }
      }
    }).catch(error => console.log(error));
  }

  getListeSite(societe?) {
    if (this.isHolding && !societe) {
      this.getSocieteFille(true);
    } else {
      if (this.infoUser['login']) {
        if (this.isHolding) {
          if (this.isHolding && societe) {
            this.common.changeUrl(this.infoUser['societe']);
          }
        }

        this.common.post('', {
          param: {
            'servlet': 'DBGetListSiteUser',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'data': {
              'NOM_UTILISATEUR': this.infoUser['login'],
              'IS_HOLDING': {
                'typeParam': 'boolean',
                'valeur': this.isHolding ? true : false
              }
            }
          }
        }).then(datas => {
          if (datas.data) {
            this.listeSite = datas.data[0] || [];
            const selectedSite = datas.data[1] || false;
            this.common.local.setObject('listeSite', this.listeSite);
            if (this.listeSite.length) {
              if (selectedSite) {
                const existSiteSelected = this.listeSite.filter(elt => elt.id === selectedSite);
                if (existSiteSelected && existSiteSelected.length) {
                  this.infoUser['site'] = selectedSite;
                } else {
                  this.infoUser['site'] = this.listeSite[0].id;
                }
              } else {
                this.infoUser['site'] = this.listeSite[0].id;
              }
            }
          }
        }).catch(error => console.log(error));
      }
    }
  }

  getUser(id) {
    return this.common.post('', {
      param: {
        'servlet': 'DBGetUser',
        'module': 'Recylog',
        'type': 'tableau',
        'compression': 'false',
        'data': [
          'DBGetUser',
          id
        ]
      }
    }).then(datas => {
      if (datas.data) {
        if (datas.data[0]) {
          datas.data[0].pwd = this.infoUser['password'];
        }

        this.common.local.setObject('userDetail', datas.data[0]);
        this.common.userDetail = datas.data[0];
        this.user = datas.data[0];
      }
    }).catch(error => console.log(error));
  }

  showPassword(input: any): any {
    this.showPass = !this.showPass;
    input.type = input.type === 'password' ? 'text' : 'password';
  }

  logout() {
    this.common.removeConnection();
    if (!environment.isOpenId) {
      this.router.navigateByUrl('/');
      this.listeSite = [];
      this.getSocieteFille();
    } else {
      this.signOut();
    }
  }

  focusNext() {
    $('#pswd').focus();
  }

  needLogin() {
    const ctrl = this;
    const Routelength = ctrl.router.url.length;
    if (this.common.isTimeout && !(!!this.common.local.getObject('userInfo') || (this.affichePagelogin))) {
      this.getSocieteFille();
    }

    if (Number(Routelength) > 1 && !(!!this.common.local.getObject('userInfo') || (this.affichePagelogin))) {
      ctrl.router.navigateByUrl('/');
    }

    return !!this.common.local.getObject('userInfo') || (this.affichePagelogin);
  }

  changeFlavicon(icon) {
    if (!this.showClient) {
      document.title = this.titleNav || '';
    }

    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link['type'] = 'image/x-icon';
    link['rel'] = 'icon';
    link['href'] = icon;
    // link['sizes'] = '32x32';
    document.getElementsByTagName('head')[0].appendChild(link);
  }

  loadStylePage() {
    const stylePage = this.common.local.getObject('stylePage');
    let urlImg = '';

    if (!environment.production) {
      const url = document.createElement('a');
      url.setAttribute('href', environment.base_url);
      urlImg = 'http://' + url.hostname + (url.port && url.port !== '' ? (':' + url.port) : '');
    } else {
      const RemoveLastDirectoryPartOf = function (the_url) {
        const the_arr = the_url.split('/');
        the_arr.pop();
        return (the_arr.join('/'));
      }
      urlImg = document.getElementsByTagName('base')[0].href;
      urlImg = RemoveLastDirectoryPartOf(RemoveLastDirectoryPartOf(urlImg));
    }

    if (!stylePage && !this.showClient && !this.needLogin()) {
      if (!this.isFin) {
        this.isFin = true;
        this.common.getLogoAndColor().then(data => {
          this.logoLoginLeft = data['nomFichierLogoAngular'] && data['nomFichierLogoAngular'] !== '' ?
            urlImg + data['nomFichierLogoAngular'] : this.logoLoginLeft;
          this.logoLoginRight = data['nomFichierLogoEcorecAngular'] && data['nomFichierLogoEcorecAngular'] !== '' ?
            urlImg + data['nomFichierLogoEcorecAngular'] : this.logoLoginRight;
          this.iconMenuLeft = data['nomFichierIconFavoris'] && data['nomFichierIconFavoris'] !== '' ?
            urlImg + data['nomFichierIconFavoris'] : this.iconMenuLeft;
          this.iconTampon = data['nomFichierIconMenuAccueil'] && data['nomFichierIconMenuAccueil'] !== '' ?
            urlImg + data['nomFichierIconMenuAccueil'] : this.iconTampon;
          this.colorMenu = data['couleurMenu'] && data['couleurMenu'] !== '' ? data['couleurMenu'] : this.iconMenuLeft;
          this.titleNav = data['titreApplication'] && data['titreApplication'] !== '' ? data['titreApplication'] : this.titleNav;
          this.changeFlavicon(this.iconMenuLeft);
          this.isFin = false;
        });
      } else {
        this.isFin = false;
      }
    } else {
      this.logoLoginLeft = stylePage['nomFichierLogoAngular'] && stylePage['nomFichierLogoAngular'] !== '' ?
        urlImg + stylePage['nomFichierLogoAngular'] : this.logoLoginLeft;
      this.logoLoginRight = stylePage['nomFichierLogoEcorecAngular'] && stylePage['nomFichierLogoEcorecAngular'] !== '' ?
        urlImg + stylePage['nomFichierLogoEcorecAngular'] : this.logoLoginRight;
      this.iconMenuLeft = stylePage['nomFichierIconFavoris'] && stylePage['nomFichierIconFavoris'] !== '' ?
        urlImg + stylePage['nomFichierIconFavoris'] : this.iconMenuLeft;
      this.iconTampon = stylePage['nomFichierIconMenuAccueil'] && stylePage['nomFichierIconMenuAccueil'] !== '' ?
        urlImg + stylePage['nomFichierIconMenuAccueil'] : this.iconTampon;
      this.colorMenu = stylePage['couleurMenu'] && stylePage['couleurMenu'] !== '' ? stylePage['couleurMenu'] : this.colorMenu;
      this.titleNav = stylePage['titreApplication'] && stylePage['titreApplication'] !== '' ?
        stylePage['titreApplication'] : this.titleNav;
      this.changeFlavicon(this.iconMenuLeft);
    }
  }

  closeRappel() {
    /** Debug : 102790 */
    if (this.israppel) {
      this.common.closeModal();
    }
    this.israppel = false;
    this.PageTitleNotification.Off();
    this.common.changeFlavicon();
  }

  loadRappel() {
    const ctrl = this;
    this.initSocket();
  }

  loadRappelSocket() {
    const ctrl = this;
    if (this.needLogin()) {
      // this.common.intervalRappel = setInterval(function () {
      ctrl.common.getRappel().then(data => {
        ctrl.listerappel = data;
        if (data.length) {
          if (!ctrl.israppel) {
            ctrl.israppel = true;
            ctrl.PageTitleNotification.On(`(${data.length}) rappels`, 1000);
            ctrl.common.openModal(ctrl.modalService, ctrl.rappel);
            $('.modal-body').click();
          }
        } else {
          ctrl.closeRappel();
        }
      });
      // }, 10000);
    }
  }

  checkedAll(event) {
    this.listerappel.forEach(elt => {
      elt.isChecked = this.checkedall;
      this.checkedRow(elt);
    });
  }

  checkedRow(selected) {
    if (selected.isChecked) {
      this.selected.push(selected);
    } else {
      this.selected.splice(this.selected.indexOf(selected), 1);
    }
  }

  hideRappel() {
    this.selected.forEach(data => {
      data.nomclass = 'DeplacementCommercial';
    });
    const param = {
      'servlet': 'DBGestionReminderDeplacementCommercial',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'CLEF_USER': {
          'typeParam': 'int',
          'valeur': this.common.user[0]
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'DEPLACEMENTS': this.selected
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        this.selected = [];
        this.common.closeModal();
        this.PageTitleNotification.Off();
        this.common.changeFlavicon();
      }
    });
  }

  removeAccesPlanning() {
    this.common.removeAccesPlanning().then(() => {
      this.common.planningInUse = false
    });
  }

  closeFunction() {
    const ctrl = this;
    /** Deblocage du planning lorsque l'utilisateur change d'onglet */
    let hidden, visibilityChange;
    if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
      hidden = 'hidden';
      visibilityChange = 'visibilitychange';
    } else if (typeof document['msHidden'] !== 'undefined') {
      hidden = 'msHidden';
      visibilityChange = 'msvisibilitychange';
    } else if (typeof document['webkitHidden'] !== 'undefined') {
      hidden = 'webkitHidden';
      visibilityChange = 'webkitvisibilitychange';
    }

    function handleVisibilityChange() {
      if (document[hidden]) {
        console.log('not active tab in browser');
        if (ctrl.common.isDragDrop && ctrl.common.planningInUse && !ctrl.common.requetteEncours) {
          ctrl.removeAccesPlanning();
          ctrl.common.planningInUse = false;
        }
        // ctrl.removeAccesPlanning();
      } else {
        console.log('active tab in browser');
      }
    }

    // Warn if the browser doesn't support addEventListener or the Page Visibility API
    if (typeof document.addEventListener === 'undefined' || hidden === undefined) {
      console.log('This demo requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.');
    } else {
      // Handle page visibility change
      document.addEventListener(visibilityChange, handleVisibilityChange, false);
    }
  }

  async consoleFct() {
    const ctrl = this;
    console.error = (function () {
      const error = console.error;
      return function (exception) {
        if (typeof exception.stack !== 'undefined') {
          const msg = `Log ${moment().format('DD/MM/YYYY HH:mm:ss')} (${window.location.href}) : ${exception.stack}`;
          if (exception.stack.includes('ERREURSERVEUR')) {
            if (exception.message) {
              const splitMsg = (exception.message || '').split('finError');
              if (splitMsg.length) {
                const errorMsg = (splitMsg[0] || '').split('ERREURSERVEUR');
                const errorRight = (splitMsg[0] || '').split('js.error.right');

                if (errorRight.length > 1 && environment.moduleEcoportailOnly) {
                  ctrl.router.navigateByUrl('/ecoportail/home');
                }
                if (errorMsg.includes('NO_ACCESS')) {
                  ctrl.common.local.removeAll();
                  ctrl.bloquerClient = true;
                  return false;
                }
                if (errorMsg.includes('USER_TOKEN_INVALID')) {
                  ctrl.index = ctrl.index + 1;
                  ctrl.objetError[ctrl.index] = 'L\'adresse mail n\'est pas configuré pour accéder à Ecorec. ';
                  ctrl.common.openModal(ctrl.modalService, ctrl.msgError);
                  return false;
                }
                if (errorMsg.includes('ERR_CONNECTION_TIMED_OUT')) {
                  if (!ctrl.pasConnexion) {
                    ctrl.pasConnexion = true;
                    ctrl.common.openModal(ctrl.modalService, ctrl.msgConsole);
                    return false;
                  } else {
                    return false;
                  }
                }


                if (errorMsg.includes('GOOGLE_CLIENT_ID_NOT_DEFINED')) {
                  ctrl.index = ctrl.index + 1;
                  ctrl.objetError[ctrl.index] = 'Veuillez revoir la configuration pour l\'accès à Google OpenID';
                  ctrl.common.openModal(ctrl.modalService, ctrl.msgError);
                  return false;
                }
                if (errorMsg.includes('TOKEN_INVALID')) {
                  ctrl.authenticate();
                } else {
                  if (errorMsg.includes('Utilisateur non authentifié') ||
                    errorMsg.includes('Utilisateur non-autentifié') ||
                    errorMsg.includes('utilisateur non-autentifié') ||
                    errorMsg.includes('session a expiré')) {
                    ctrl.common.removeConnection();
                    ctrl.authenticate();
                    ctrl.getSocieteFille();
                    return false;
                  } else {
                    if (errorMsg.length) {
                      ctrl.index = ctrl.index + 1;
                      ctrl.objetError[ctrl.index] = errorMsg[errorMsg.length - 1] ?
                        errorMsg[errorMsg.length - 1] : '';
                      if ((ctrl.objetError[ctrl.index] || '').includes('Server error')) {
                        // ctrl.sendError(exception.stack, true);
                      }
                      if ((ctrl.objetError[ctrl.index] || '').includes('NO_ACCESS')) {
                        ctrl.common.local.removeAll();
                        ctrl.bloquerClient = true;
                        return false;
                      }
                      if ((ctrl.objetError[ctrl.index] || '').includes('USER_TOKEN_INVALID')) {
                        ctrl.objetError[ctrl.index] =
                          'L\'adresse mail n\'est pas configuré pour accéder à Ecorec. ';
                        ctrl.common.openModal(ctrl.modalService, ctrl.msgError);
                        return false;
                      }
                      if ((ctrl.objetError[ctrl.index] || '').includes('ERR_CONNECTION_TIMED_OUT')) {
                        if (!ctrl.pasConnexion) {
                          ctrl.pasConnexion = true;
                          ctrl.common.openModal(ctrl.modalService, ctrl.msgConsole);
                          return false;
                        } else {
                          return false;
                        }
                      }
                      if ((ctrl.objetError[ctrl.index] || '').includes('GOOGLE_CLIENT_ID_NOT_DEFINED')) {
                        ctrl.objetError[ctrl.index] =
                          'Veuillez revoir la configuration pour l\'accès à Google OpenID';
                        ctrl.common.openModal(ctrl.modalService, ctrl.msgError);
                        return false;
                      }
                      if ((ctrl.objetError[ctrl.index] || '').includes('TOKEN_INVALID')) {
                        ctrl.authenticate();
                      }
                      if ((ctrl.objetError[ctrl.index] || '').includes('Utilisateur non authentifié') ||
                        (ctrl.objetError[ctrl.index] || '').includes('Utilisateur non-autentifié') ||
                        (ctrl.objetError[ctrl.index] || '').includes('utilisateur non-autentifié') ||
                        (ctrl.objetError[ctrl.index] || '').includes('session a expiré')) {
                        ctrl.common.removeConnection();
                        ctrl.authenticate();
                        ctrl.getSocieteFille();
                        return false;
                      } else {
                        if (ctrl.objetError[ctrl.index] && ctrl.objetError[ctrl.index] !== '') {
                          ctrl.common.openModal(ctrl.modalService, ctrl.msgError);
                          setTimeout(function () {
                            $('.cofirmemsg').click();
                          }, 200)
                        }
                      }
                    }
                  }
                }

              }
            }

          } else {
            const chunkFailedMessage = /Loading chunk [\d]+ failed/;
            if (chunkFailedMessage.test(exception.message)) {
              window.location.reload();
            } else {
              error.call(console, exception.stack);
              ctrl.sendError(msg);
            }
          }
        } else {
          if (typeof exception === 'string') {
            if ((exception || '').includes('ERREURSERVEUR')) {
              if (exception) {
                const splitMsg = (exception || '').split('finError');
                if (splitMsg.length) {
                  const errorMsg = (splitMsg[0] || '').split('ERREURSERVEUR');
                  const errorRight = (splitMsg[0] || '').split('js.error.right');

                  if (errorRight.length > 1 && environment.moduleEcoportailOnly) {
                    ctrl.router.navigateByUrl('/ecoportail/home');
                  }

                  if (errorMsg.includes('NO_ACCESS')) {
                    ctrl.common.local.removeAll();
                    ctrl.bloquerClient = true;
                    return false;
                  }

                  if (errorMsg.includes('USER_TOKEN_INVALID')) {
                    ctrl.index = ctrl.index + 1;
                    ctrl.objetError[ctrl.index] = 'L\'adresse mail n\'est pas configuré pour accéder à Ecorec. ';
                    ctrl.common.openModal(ctrl.modalService, ctrl.msgError);
                    return false;
                  }
                  if (errorMsg.includes('ERR_CONNECTION_TIMED_OUT')) {
                    if (!ctrl.pasConnexion) {
                      ctrl.pasConnexion = true;
                      ctrl.common.openModal(ctrl.modalService, ctrl.msgConsole);
                      return false;
                    } else {
                      return false;
                    }
                  }
                  if (errorMsg.includes('GOOGLE_CLIENT_ID_NOT_DEFINED')) {
                    ctrl.index = ctrl.index + 1;
                    ctrl.objetError[ctrl.index] = 'Veuillez revoir la configuration pour l\'accès à Google OpenID';
                    ctrl.common.openModal(ctrl.modalService, ctrl.msgError);
                    return false;
                  }
                  if (errorMsg.includes('TOKEN_INVALID')) {
                    ctrl.authenticate();
                  } else {
                    if (errorMsg.includes('Utilisateur non authentifié') ||
                      errorMsg.includes('Utilisateur non-autentifié') ||
                      errorMsg.includes('utilisateur non-autentifié') ||
                      errorMsg.includes('session a expiré')) {
                      ctrl.common.removeConnection();
                      ctrl.authenticate();
                      ctrl.getSocieteFille();
                      return false;
                    } else {
                      if (errorMsg.length) {
                        ctrl.index = ctrl.index + 1;
                        ctrl.objetError[ctrl.index] = errorMsg[errorMsg.length - 1] ?
                          errorMsg[errorMsg.length - 1] : '';
                        if ((ctrl.objetError[ctrl.index] || '').includes('Server error')) {
                          // ctrl.sendError(exception, true);
                        }
                        if ((ctrl.objetError[ctrl.index] || '').includes('NO_ACCESS')) {
                          ctrl.common.local.removeAll();
                          ctrl.bloquerClient = true;
                          return false;
                        }
                        if ((ctrl.objetError[ctrl.index] || '').includes('USER_TOKEN_INVALID')) {
                          ctrl.objetError[ctrl.index] =
                            'L\'adresse mail n\'est pas configuré pour accéder à Ecorec. ';
                          ctrl.common.openModal(ctrl.modalService, ctrl.msgError);
                          return false;
                        }
                        if ((ctrl.objetError[ctrl.index] || '').includes('ERR_CONNECTION_TIMED_OUT')) {
                          if (!ctrl.pasConnexion) {
                            ctrl.pasConnexion = true;
                            ctrl.common.openModal(ctrl.modalService, ctrl.msgConsole);
                            return false;
                          } else {
                            return false;
                          }
                        }
                        if ((ctrl.objetError[ctrl.index] || '').includes('GOOGLE_CLIENT_ID_NOT_DEFINED')) {
                          ctrl.objetError[ctrl.index] =
                            'Veuillez revoir la configuration pour l\'accès à Google OpenID';
                          ctrl.common.openModal(ctrl.modalService, ctrl.msgError);
                          return false;
                        }
                        if ((ctrl.objetError[ctrl.index] || '').includes('TOKEN_INVALID')) {
                          ctrl.authenticate();
                        } else {
                          if ((ctrl.objetError[ctrl.index] || '').includes('Utilisateur non authentifié') ||
                            (ctrl.objetError[ctrl.index] || '').includes('Utilisateur non-autentifié') ||
                            (ctrl.objetError[ctrl.index] || '').includes('utilisateur non-autentifié') ||
                            (ctrl.objetError[ctrl.index] || '').includes('session a expiré')) {
                            ctrl.common.removeConnection();
                            ctrl.authenticate();
                            ctrl.getSocieteFille();
                            return false;
                          } else {
                            if (ctrl.objetError[ctrl.index] && ctrl.objetError[ctrl.index] !== '') {
                              ctrl.common.openModal(ctrl.modalService, ctrl.msgError);
                              setTimeout(function () {
                                $('.cofirmemsg').click();
                              }, 200)
                            }
                          }
                        }
                      }
                    }
                  }

                }
              }
            } else {
              console.log(console, arguments)
              error.apply(console, arguments);
            }
          } else {
            console.log(console, arguments)
            error.apply(console, arguments);
          }
          // error.apply(console, arguments);
        }
      };
    })();
  }

  sendError(logmsg, notPopup?) {
    const param = {
      'servlet': 'DBGestionLogAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'USER': {
          'typeParam': 'int',
          'valeur': this.common.user[0] || '0'
        },
        'LOG': logmsg,
      }
    };

    if (!logmsg.includes('ExpressionChangedAfterItHasBeenCheckedError') &&
      !logmsg.includes('Observable.fromEvent is not a function') && !logmsg.includes('fromEvent is not a function')) {
      if (!notPopup) {
        this.common.openModal(this.modalService, this.msgConsole);
        if (logmsg.includes('exceeded the quota.') ||
          logmsg.includes('QuotaExceededError: Failed to execute')) {
          localStorage.clear();
          this.common.removeConnection();
        }
      }
      if (environment.production) {
        if (environment.moduleEcoportailOnly) {
          return this.common.postEcoportail('undefined/society/save/logAngular', { log: logmsg });
        } else {
          return this.common.post('', { param: param });
        }
      }
    }
  }

  fctClose() {
    let locations: any = window.location.href;
    let isReload = true;
    if (locations && locations.includes("param/systeme/user")) {
      isReload = false;
    }

    if (isReload) {
      location.reload();
    }
    return false;
  }

  getChampVisible() {
    const listAssoChampFicheClientModule = this.common.getType('assoChampFicheClientModule') || [];
    for (let i = 0; i <= 250; i++) {
      this.common.visibleChamp['clt' + i] = this.common.visibleChampFicheClient(i, listAssoChampFicheClientModule);
      this.common.visibleChamp['cltObj' + i] = this.common.getChampClient(i);
    }

    const listAssoChampFicheChantierModule = this.common.getType('assoChampFicheChantierModule') || [];

    for (let i = 1; i <= 77; i++) {
      this.common.visibleChamp['cht' + i] = this.common.visibleChampFicheChantier(i, listAssoChampFicheChantierModule);
    }

    const listAssoChampFichePersonnel = this.user.listeAccesFicheChauffeur || []
    const listAssoChampFicheArticle = this.user.listeAccesFicheArticle || []

    if (!listAssoChampFichePersonnel.length) {
      for (let i = 1; i <= 107; i++) {
        this.common.visibleChamp['persObj' + i] = {
          creation: true,
          modifiable: true,
          vision: true,
          libelle: true,
          visible: true
        };
      }
    } else {
      listAssoChampFichePersonnel.forEach((el, i) => {
        const id = el.champ && el.champ.id ? el.champ.id : 0
        this.common.visibleChamp['persObj' + id] = {
          creation: el.creation || false,
          modifiable: el.modifiable || false,
          vision: el.vision || false,
          libelle: el.champ.libelle || '',
          visible: id ? true : false
        }
      });
    }

    if (!listAssoChampFicheArticle.length) {
      for (let i = 1; i <= 142; i++) {
        this.common.visibleChamp['artObj' + i] = {
          creation: true,
          modifiable: true,
          vision: true,
          libelle: true,
          visible: true
        };
      }
    } else {

      listAssoChampFicheArticle.forEach((el, i) => {
        const id = el.champ && el.champ.id ? el.champ.id : 0
        this.common.visibleChamp['artObj' + id] = {
          creation: el.creation || false,
          modifiable: el.modifiable || false,
          vision: el.vision || false,
          libelle: el.champ.libelle || '',
          visible: id ? true : false
        }
      });

      for (let i = 1; i <= 142; i++) {
        const existe = listAssoChampFicheArticle.filter(el => el.id === i);
        if (!existe || (existe && !existe.length)) {
          this.common.visibleChamp['artObj' + i] = {
            creation: true,
            modifiable: true,
            vision: true,
            libelle: true,
            visible: true
          };
        }
      }

    }
    // console.log('this.common.visibleChamp',this.common.visibleChamp)
  }

  scrollMenuBottom() {
    const menu = $('#menu')
    const offsetTop = menu[0].clientHeight;
    const ctrl = this;
    $('#menu').animate({ // animate element that has scroll
      scrollLeft: $('#menu').scrollLeft() + 100 // for scrolling
    }, 1000);
  }

  scrollMenuTop() {
    $('#menu').animate({ // animate element that has scroll
      scrollLeft: $('#menu').scrollLeft() - 100 // for scrolling
    }, 1000);
  }

  menuSelected() {
    let activeModule = '';
    const url = window.location.href || '';
    if (url.includes('/ecoloc')) {
      this.common.clickMenu['ecoloc'] = true;
      activeModule = 'ecoloc';
    }
    if (url.includes('/ecofact')) {
      this.common.clickMenu['ecofact'] = true;
      activeModule = 'ecofact';
    }
    if (url.includes('/ecobennes')) {
      this.common.clickMenu['ecobennes'] = true;
      activeModule = 'ecobennes';
    }
    if (url.includes('/ecocrm')) {
      this.common.clickMenu['ecogrc'] = true;
      activeModule = 'ecogrc';
    }
    if (url.includes('/ecobac')) {
      this.common.clickMenu['ecobac'] = true;
      activeModule = 'ecobac';
    }
    if (url.includes('/ecorh')) {
      this.common.clickMenu['ecorh'] = true;
      activeModule = 'ecorh';
    }
    if (url.includes('/ecodechet')) {
      this.common.clickMenu['ecodechet'] = true;
      activeModule = 'ecodechet';
    }
    if (url.includes('/ecodec/')) {
      this.common.clickMenu['ecodec'] = true;
      activeModule = 'ecodec';
    }
    if (url.includes('/ecodd')) {
      this.common.clickMenu['ecodd'] = true;
      activeModule = 'ecodd';
    }
    if (url.includes('/ecotri')) {
      this.common.clickMenu['ecotri'] = true;
      activeModule = 'ecotri';
    }
    if (url.includes('/ecostock')) {
      this.common.clickMenu['ecostock'] = true;
      activeModule = 'ecostock';
    }
    return activeModule;
  }

  async getDetail(id) {
    const param = {
      'servlet': 'DBGetInfoSite',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetInfoSite', '' + id]
    };
    await this.common.post('', { param: param }).then(dt => {
      if (dt.message) {
        this.error = dt.message;
        this.common.openModal(this.modalService, this.msg);
      } else {
        const site = dt.data[0];
        this.common.local.setObject('siteUser', site);
      }
    });
  }

  async getDBGetParametresHolding(login) {

    const param = {
      'OPERATION': {
        'typeParam': 'int',
        'valeur': 1
      },
      'SOUS_OPERATION': {
        'typeParam': 'int',
        'valeur': 1
      },
    }
    if (this.isHolding) {
      await this.common.DBGestionParamHoldingAngular(param).then(dt => {
        if (dt && dt.data !== null) {
          const paramH = dt.data;
          this.common.local.setObject('paramHolding', paramH);
        }
        // this.getSocieteHolding();
        return this.DBGetUserHolding(login);
      });
    } else {
      return Promise.resolve()
    }

  }

  async DBGetUserHolding(login) {
    const param = {
      'OPERATION': {
        'typeParam': 'int',
        'valeur': 1
      },
      'SOUS_OPERATION': {
        'typeParam': 'int',
        'valeur': 5
      },
    }
    await this.common.DBGestionParamHoldingAngular(param).then(dt => {
      if (dt && dt.data !== null) {
        const paramH = dt.data;
        this.common.local.setObject('userHolding', paramH);
      }
    });
  }

  async getSocieteFille(recharge?) {
    this.common.isTimeout = false;
    const param = {
      'servlet': 'DBGetListSociete',
      'module': 'Recylog',
      'type': 'objet',
      'compression': 'false',
      'data': {
        'typeParam': 'string',
        'valeur': this.infoUser['login'] || ''
      }
    };
    if (!environment.moduleEcoportailOnly) {
      await this.common.postHolding('', { param: param }).then(dt => {
        if (dt.data !== null) {
          this.listeSociete = dt.data || [];
          if (this.listeSociete.length) {
            if ((!this.infoUser['societe'] || (this.infoUser['societe'] && !this.infoUser['societe'].id))) {
              this.infoUser['societe'] = this.listeSociete[0];
            } else {
              const isExiste = this.listeSociete.filter(elt => elt.id === this.infoUser['societe'].id);
              this.listeSociete.forEach(elt => {
                if (elt.id === this.infoUser['societe'].id) {
                  this.infoUser['societe'] = elt;
                }
              });
              if (!isExiste || (isExiste && !isExiste.length)) {
                this.infoUser['societe'] = this.listeSociete[0];
              }
            }
          } else {
            this.infoUser['societe'] = { id: 0 }
          }

          console.log('infoUser[\'societe\']', this.infoUser['societe']);
          this.isHolding = this.listeSociete.length ? true : false;
          if (!recharge) {
            this.isHolding = this.listeSociete.length ? true : false;
            if (this.isHolding) {
              this.common.local.set('isHolding', '' + this.isHolding);
              this.getSocieteHolding();
            } else {
              this.common.local.remove('isHolding');
              this.common.local.remove('nomBDHolding');
            }
          } else {
            if (this.listeSociete.length) {
              this.getListeSite(true);
              this.common.local.set('isHolding', '' + true);
            } else {
              this.common.local.remove('isHolding');
              this.common.local.remove('nomBDHolding');
            }
          }

          this.common.listeSociete = this.listeSociete;
          this.common.isHolding = this.common.listeSociete.length > 0;
        }
      });
    } else {
      await Promise.resolve();
    }

  }

  async getSocieteHolding() {
    const param = {
      'servlet': 'DBGetSociete',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': []
    };

    await this.common.postHolding('', { param: param }).then(data => {
      if (data.data) {
        const nomBDHolding = { nomBDHolding: data.data['nomBD'] || '' };
        this.common.local.setObject('nomBDHolding', nomBDHolding);
      }
    }).catch(error => console.log(error));
  }

  async signOut() {
    const ctrl = this;
    ctrl.common.local.remove('user');
    this.router.navigateByUrl('/empty');
    if (gapi.auth2) {
      const auth2 = gapi.auth2.getAuthInstance();
      auth2.signOut().then(function () {
        window.close();
      });
    }
  }

  loginEcoportail() {
    return this.common.postEcoportail('user/login', {
      'user': {
        login: this.infoUser['login'],
        pwd: this.infoUser['password'],
        essaiUsers: true
      }
    });
  }

  verificationMail() {
    const isDepuisHome = this.paramLogin['isDepuishome'];
    const depuisPassOubtn = this.paramLogin['depuisPassOubtn'];
    this.isModalMail = false;
    this.login(isDepuisHome, depuisPassOubtn);
  }

  validate_mail(mail) {
    const verifFormatMail = mail
      .trimEnd()
      .match('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$');
    console.log('verifFormatMail', verifFormatMail);
    return verifFormatMail != null ? true : false;
  }


  checkValidmail() {
    if (!this.validate_mail(this.objTwoFactorAuth['mail'])) {
      this.changerCouleurMail = false;
    } else {
      this.changerCouleurMail = true;
    }
  }

  startTimer(type) {
    this.updateTime();
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        this.updateTime();
      } else {
        clearInterval(this.interval);
        if (type === 0)
          this.objTwoFactorAuth['error'] = "Votre code a expiré. Veuillez en demander un nouveau."
        else
          this.objTwoFactorAuth['error'] = "Temps d'attente de l'identification à double facteur depassé."
      }
    }, 1000);
  }

  updateTime() {
    this.minutes = Math.floor(this.timeLeft / 60);
    this.seconds = this.timeLeft % 60;
  }


  focusToNext(event: any, index: number) {
    const nextInputId = `code${index + 1}`;
    this.objTwoFactorAuth['error'] = "";
    const nextInput = document.getElementById(nextInputId);
    if (nextInput && event.target.value.length === 1) {
      nextInput.focus();
    }
    this.isCodevalidationRempli = this.isCodeComplete();
  }

  validateCode() {
    this.objTwoFactorAuth['codeString'] = this.objTwoFactorAuth['code'].join('')
    const isDepuisHome = this.paramLogin['isDepuishome'];
    const depuisPassOubtn = this.paramLogin['depuisPassOubtn']
    this.login(isDepuisHome, depuisPassOubtn);
  }

  handlePaste(event: ClipboardEvent): void {
    let clipboardData = event.clipboardData?.getData('text');
    if (clipboardData) {
      clipboardData = clipboardData.replace(/\s+/g, '');
      if (clipboardData.length === 6) {
        for (let i = 0; i < 6; i++) {
          this.objTwoFactorAuth.code[i] = clipboardData[i];
        }
      }
    }

    this.isCodevalidationRempli = this.isCodeComplete();
    event.preventDefault();
  }


  initialiseObjwofact() {
    console.log('isFocuspass', this.isFocuspass, this.isModalMail)
    clearInterval(this.interval);
    this.timeLeft = 15 * 60;
    if (!this.isModalMail) {
      this.objTwoFactorAuth = {
        code: ['', '', '', '', '', '']
      };
    }


    console.log('initialiseObjwofact', this.objTwoFactorAuth)
  }

  isCodeComplete(): boolean {
    if (Array.isArray(this.objTwoFactorAuth.code) && this.objTwoFactorAuth.code.length === 6) {
      return this.objTwoFactorAuth.code.every((digit: string) => digit !== '');
    }
    return false;
  }

  submitMailOnEnter() {
    if (this.changerCouleurMail) {
      this.common.closeModal();
      this.verificationMail();
    }
  }

  validateCodeOnenter() {
    if (this.isCodevalidationRempli) {
      this.validateCode();
    }
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
        },
        (error) => {
          console.error("Permission refusée ou erreur :", error);
        });
    } else {
      console.error("Permission refusée ou erreur :");
    }
  }

  ckeckResponseNotificationFirebase() {
    const isDepuisHome = this.paramLogin['isDepuishome'];
    const depuisPassOubtn = this.paramLogin['depuisPassOubtn']
    this.login(isDepuisHome, depuisPassOubtn);
  }

  sendMailOnErrorEcoDA() {
    this.isSendMailErrorEcoDA = true;
    this.isModalPanneauAttenteValidationApp = false;
    const isDepuisHome = this.paramLogin['isDepuishome'];
    const depuisPassOubtn = this.paramLogin['depuisPassOubtn'];
    this.common.closeModal();
    this.login(isDepuisHome, depuisPassOubtn);
  }

  addLinkOrScript(href: string, as: 'script' | 'style' = 'script') {
    if (as === 'style') {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;        // ex: 'primeng-theme.css' ou 'dd-XYZ.js'
      document.head.appendChild(link);
    } else {
      const link = document.createElement('script');

      link.src = href;        // ex: 'primeng-theme.css' ou 'dd-XYZ.js'
      document.head.appendChild(link);
    }

  }

}

function ngOnDestroy() {
  throw new Error('Function not implemented.');
}

